<script setup>
const {isOpen, closeIcon, width} = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  closeIcon: {
    type: Boolean,
    default: false
  },
  width: {
    type: Number,
    default: 400
  },
  wrapperClass: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['close', 'confirm'])

// Close modal on Esc click.
useEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    emit('close')
  }
})

</script>
<template>
  <div v-if="isOpen" class="z-[500] fixed inset-0 flex items-center justify-center bg-darkBlue bg-opacity-50">
    <div class="bg-white py-6 rounded-[40px] shadow-lg min-w-[100px] max-w-[97%]" :style="{ width: width ? `${width}px` : '' }" :class="{ 'w-1/2 xl:w-1/3': !width, [wrapperClass]: wrapperClass }">
      <div class="px-6 mx-4 lg:mx-0 lg:px-10 max-h-[90vh] overflow-y-auto scrollbar scrollbar--round scrollbar--dark">
        <div v-if="closeIcon">
          <slot name="closeIcon">
            <div class="relative w-full">
              <IconCloseButton class="size-6 absolute right-0 cursor-pointer" @click="emit('close')" />
            </div>
          </slot>
        </div>
        <div class="text-center text-2xlg lg:text-30">
          <slot name="header">
          </slot>
        </div>
        <div>
          <slot name="content">
          </slot>
        </div>
        <div>
          <slot name="footer">
            <div class="flex justify-end mt-4">
              <button class="px-4 h-10 text-darkBlue border border-darkBlue rounded-lg" @click="emit('close')">
                {{ $t('cancel') }}
              </button>
              <button class="ml-2 px-4 h-10 bg-darkBlue hover:bg-lightBlue text-white rounded-lg transition-all duration-50 active:scale-95" @click="emit('confirm')">
                {{ $t('confirm') }}
              </button>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>